import {HealthIndicatorsApi, KilnInfo} from '@domain/kiln-monitoring'
import {ExpandMore as ExpandMoreIcon} from '@mui/icons-material'
import {Button, MenuItem, Skeleton, Typography, Menu, Stack} from '@mui/material'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {KMS_WIDGET_NAMESPACE} from '../../consts'

import {KilnMetricStatusGrid} from './KilnMetricStatusGrid'
import {KilnSensorAreaStatusGrid} from './KilnSensorAreaStatusGrid'

const gridItemSettings = {
  xs: 5,
  sm: 3,
  md: 4,
  lg: 4
}

export const KilnMonitoringPanel = ({
  isLoading,
  kilns,
  selectedKiln,
  isLoadingHealthIndicators,
  healthIndicators,
  isLoadingSensors,
  sensorAreas,
  onSelectedKilnChange
}: {
  isLoading: boolean
  kilns?: KilnInfo[]
  selectedKiln?: KilnInfo
  isLoadingHealthIndicators: boolean
  healthIndicators?: HealthIndicatorsApi
  isLoadingSensors: boolean
  sensorAreas?: Record<string, string>
  onSelectedKilnChange: (kilnId: string) => void
}) => {
  const {t} = useTranslation(KMS_WIDGET_NAMESPACE)

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const open = Boolean(anchorEl)
  const hasMultipleKilns = !!kilns?.length && kilns.length > 1

  return (
    <Stack spacing={3} sx={{maxHeight: '100%'}}>
      {hasMultipleKilns && (
        <div>
          <Button
            onClick={(event) => setAnchorEl(event.currentTarget)}
            variant="text"
            endIcon={<ExpandMoreIcon />}
            sx={{pl: 0, justifyContent: 'flex-start', display: 'flex'}}
            disabled={isLoading}
          >
            <Typography variant="h4" color="text.primary">
              {isLoading && <Skeleton variant="text" width={60} height={30} />}
              {!isLoading ? selectedKiln?.name || t('kilnMonitoring.label.unnamedKiln') : null}
            </Typography>
          </Button>
        </div>
      )}
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {kilns?.map((kiln) => (
          <MenuItem
            key={kiln.id}
            selected={kiln.id === selectedKiln?.id}
            onClick={() => {
              onSelectedKilnChange(kiln.id)
              setAnchorEl(null)
            }}
          >
            {kiln.name || kiln.id}
          </MenuItem>
        ))}
      </Menu>

      {selectedKiln && (
        <Stack spacing={2}>
          <KilnMetricStatusGrid
            isLoading={isLoadingHealthIndicators}
            kilnInfo={selectedKiln}
            healthIndicators={healthIndicators}
            gridItemSettings={gridItemSettings}
          />
          <KilnSensorAreaStatusGrid
            sensorAreas={sensorAreas}
            isLoading={isLoadingSensors}
            gridItemSettings={gridItemSettings}
          />
        </Stack>
      )}
    </Stack>
  )
}
